import React, { useEffect, useState } from "react";
import qt from "@qt-base/jssdk";
import wxShare from "@qt-wx/share";
import "@qt-web/rem-standard";
import "@qt-web/css-common";
import { Provider } from "@qt-builder/material-context";
import Toast from "@qt-react/toast";
import "@qt-react/toast/dist/index.css";
import axios from "axios";
import componentsCtrl from "@qt-builder/components-ctrl";
import Expose from "@qt-react/common-expose";
import jssdk from "@qt-base/jssdk";
import { useRef, useEffect as useEffect__10 } from "react";
window.__BUILDER_PROJECT_ID = '612c45806d40ddb5168df48e';
window.__BUILDER_PAGE_ID = '612c45806d40dd30b88df48f';
window.__BUILDER_COMPONENTS_CTRL = '{}';
componentsCtrl.init({});
const isInApp = qt.env.inApp;
wxShare.initShare(process.env.SITE_ENV);

const formatTime = time => {
  const newTime = new Date(time.replace(/-/g, '/'));
  return newTime;
};

const isExpire = (endTime, useServerTime, serverTime) => {
  let currentTime = new Date();

  if (useServerTime && serverTime > 0) {
    currentTime = new Date(serverTime);
  }

  if (endTime) {
    const newEndTime = formatTime(endTime);

    if (currentTime > newEndTime) {
      return true;
    }
  }

  return false;
};

const isNotStart = (startTime, useServerTime, serverTime) => {
  let currentTime = new Date();

  if (useServerTime && serverTime > 0) {
    currentTime = new Date(serverTime);
  }

  if (startTime) {
    const newStartTime = formatTime(startTime);

    if (currentTime < newStartTime) {
      return true;
    }
  }

  return false;
};

const getDisplayBlock = (startTime, endTime, useServerTime, serverTime) => {
  let display = "block";

  if (endTime && isExpire(endTime, useServerTime, serverTime) || startTime && isNotStart(startTime, useServerTime, serverTime)) {
    display = 'none';
  }

  return display;
};

const getShareLink = () => {
  const url = window.location.href;
  return url;
};

const getHeight = () => {
  const winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  return winHeight;
};

const ContainerRender = ({
  basicConfig: basicConfig,
  containerConfig: containerConfig,
  serverTime: serverTime,
  children: children,
  id = "",
  nodeId = "",
  nodeType = ""
}) => {
  const shareConfig = {
    title: basicConfig.shareTitle,
    desc: basicConfig.shareSubTitle,
    imageUrl: basicConfig.shareImg,
    link: basicConfig.shareLink || getShareLink()
  };
  const wxShareConfig = {
    title: basicConfig.shareTitle,
    desc: basicConfig.shareSubTitle,
    imgUrl: basicConfig.shareImg,
    link: basicConfig.shareLink || getShareLink()
  }; //微信分享

  if (wxShare.isInWeixin) {
    if (basicConfig.isHiddenWxShare) {
      wxShare.hiddenShareItems();
    } else {
      wxShare.setShareConfig(wxShareConfig);
    }
  }

  if (isInApp) {
    window.onPageAppear = async () => {
      await qt.page.setNavbar({
        show: true
      });
    };

    qt.page.setNavbar({
      hideShare: basicConfig.isHiddenAppShare
    });
    qt.page.setShare(shareConfig);
  }

  let inIosApp = qt.env.inIosApp;

  if (inIosApp) {
    window.addEventListener('hashchange', function () {
      qt.page.setShare(shareConfig);
    });
  }

  useEffect(() => {
    qt.monitor.bmsPageViewEntry({
      eventId: 'componentContainer_view',
      nodeId,
      nodeType
    });
    document.title = basicConfig.title;
    document.body.style.fontSize = '16px';
    document.body.style.background = containerConfig.bgc;
    document.body.style.backgroundImage = containerConfig.bgimg;
    document.body.style.backgroundRepeat = 'repeat';
    document.getElementById('root').minHeight = window.innerHeight;

    if (inIosApp) {
      return window.removeEventListener('hashchange', () => {});
    }
  }, []);
  const {
    startTime,
    endTime,
    useServerTime,
    endTitle,
    beforeTitle,
    endRedirectUrl,
    redirectPromp,
    bgc,
    themeColor,
    bgimg,
    style,
    margin,
    padding
  } = containerConfig;
  const isExpireShow = isExpire(endTime, useServerTime, serverTime);
  const tip = endTime && isExpireShow ? endTitle ? endTitle : '页面已过期' : beforeTitle ? beforeTitle : '活动还未开始，敬请期待~';
  const display = getDisplayBlock(startTime, endTime, useServerTime, serverTime);
  const currentStyle = {
    background: bgc,
    color: themeColor,
    minHeight: getHeight(),
    backgroundImage: `url(${bgimg})`,
    backgroundRepeat: 'repeat',
    margin,
    padding
  };
  const useStyle = Object.assign({
    overflowX: 'hidden'
  }, currentStyle, style); // == 已结束并存在下架地址则重定向至对应地址

  const hasEndRedirectUrl = endRedirectUrl && endRedirectUrl.replace(/\s+/g, '') && endRedirectUrl !== window.location.href;

  if (endTime && isExpireShow && hasEndRedirectUrl) {
    Toast.info({
      content: redirectPromp,
      duration: 3000
    });
    setTimeout(() => {
      window.location.replace(endRedirectUrl);
    }, 3000);
    return null;
  }

  return display === 'block' ? <div style={useStyle}>{children}</div> : <div style={{
    minHeight: getHeight(),
    display: 'flex',
    alignItems: 'center'
  }}>
			<div style={{
      textAlign: 'center',
      transform: 'translateY(-1rem)',
      width: '100%'
    }}>
				<div className='m-auto' style={{
        width: 150
      }}>
					<img className='wd-100' alt={'logo'} src={'https://pic.qingting.fm/activity/123/qtlogo.png'} />
				</div>
				<div className='gray-333 f18 text-center pt-2'>{tip}</div>
			</div>
		</div>;
};

const ContainnerProvider = Provider('containnerProvider', ({
  context,
  children,
  basicConfig,
  ...props
}) => {
  const [shareConfig, setShareConfig] = useState(basicConfig);
  const [serverTime, setServerTime] = useState(0);
  context.shareConfig = shareConfig;
  context.setShareConfig = setShareConfig;
  context.serverTime = serverTime;
  context.useServerTime = props.containerConfig.useServerTime;
  useEffect(() => {
    if (props.containerConfig.useServerTime) {
      axios.get(`https://webbff${process.env.SITE_ENV === 'stg' ? '.staging' : ''}.qingting.fm/common/currentTime`).then(({
        data
      }) => {
        setServerTime(data.current);
      }).catch(() => setServerTime(-1));
    } else {
      setServerTime(-1);
    }
  }, []);
  return serverTime !== 0 ? <ContainerRender children={children} basicConfig={shareConfig} serverTime={serverTime} {...props}></ContainerRender> : null;
});

const CommonImage = ({
  config: config,
  sendLog: sendLog,
  imageStyle: imageStyle
}) => {
  const {
    openLazyload
  } = config;
  const imgRef = React.useRef();
  const [measure, setMeasure] = React.useState();
  const [load, setLoad] = React.useState(false);

  const getScrollTop = () => {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  };

  React.useEffect(() => {
    if (!config.src) return;
    window.addEventListener("load", () => {
      const elem = imgRef.current;
      if (!elem) return;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const scrollTop = getScrollTop();
      const offsetTop = scrollTop + elem.getBoundingClientRect().top;
      const initMeasure = {
        offsetTop,
        windowHeight,
        load: scrollTop + windowHeight >= offsetTop
      };
      setMeasure(initMeasure);
    });
  }, []); // == 懒加载监听

  React.useEffect(() => {
    if (!openLazyload || !measure || measure.load || load) return;
    const {
      offsetTop,
      windowHeight
    } = measure;

    const lazyloadListener = () => {
      const scrollTop = getScrollTop();
      const isLoad = scrollTop + windowHeight >= parseInt(offsetTop) - 30; // 提前30像素加载

      if (isLoad) setLoad(isLoad);
    };

    window.addEventListener("scroll", lazyloadListener);
    return () => {
      window.removeEventListener("scroll", lazyloadListener);
    };
  }, [measure, load]);
  return config.src ? openLazyload ? <Expose seconds={10} openDebugger={process.env.SITE_ENV === "stg"} expose={() => {
    sendLog("expose");
  }}>
        <img ref={imgRef} className={`block lh-100 ${measure && measure.load || load ? "" : "invisible "}`} width="100%" style={imageStyle} src={measure && measure.load || load ? config.src : null} />
      </Expose> : <Expose seconds={10} openDebugger={process.env.SITE_ENV === "stg"} expose={() => {
    sendLog("expose");
  }}>
        <img ref={imgRef} className={`block lh-100`} width="100%" style={imageStyle} src={config.src} />
      </Expose> : <div className="text-center mv-3 f14">请添加图片</div>;
};

const SingleImage = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  config: config,
  containerStyle: containerStyle,
  imageStyle: imageStyle,
  children: children
}) => {
  const {
    origin,
    pathname,
    search
  } = window.location;
  const {
    link,
    linkInApp,
    linkOutApp,
    openNewWebview,
    openExpose
  } = config;
  const isInApp = qt.env.inApp;
  const envLink = isInApp ? linkInApp || link : linkOutApp || link;
  const isAnchorId = envLink.length === 3;
  const finalLink = isAnchorId ? origin + pathname + search + `#${envLink}` : envLink; // == 发送日志

  const sendLogRef = React.useRef((label = "click") => {
    if (label === "expose") {
      if (!finalLink && !openExpose) return;
      qt.monitor.bmsExpose({
        eventId: "image_view",
        nodeId,
        nodeType,
        data: {
          expose_primary_type: "H5",
          expose_primary_id: finalLink
        }
      });
    } else {
      qt.monitor.bmsActionEvent({
        eventId: "image_click",
        nodeId,
        nodeType,
        data: {
          action_primary_type: "H5",
          action_primary_id: finalLink
        }
      });
    }
  });
  return finalLink ? <a id={id} className="block" style={containerStyle} onClick={e => {
    e.stopPropagation();
    sendLogRef.current();

    if (isInApp && openNewWebview) {
      qt.route.openNewWebview({
        url: finalLink
      });
    } else {
      const {
        hash
      } = new URL(finalLink);
      if (hash) window.location.href = finalLink;else window.open(finalLink);
    }
  }}>
      <CommonImage sendLog={sendLogRef.current} finalLink={finalLink} config={config} imageStyle={imageStyle} />
      {children}
    </a> : <div id={id} style={containerStyle}>
      <CommonImage sendLog={sendLogRef.current} config={config} imageStyle={imageStyle} />
      {children}
    </div>;
};

const isDynamicChannel = false;
const channelId = "408976";
const channelData = {
  title: "大头诗词会（付费订阅）",
  description: "订阅后务必加微信datouzhuli666，进入【大头诗词会专属社群】享社群服务",
  cover: "https://sss.qingting.fm/bp/612c45806d40ddb5168df48e/image/eb428be9984b5817f76b655be554ec79.png",
  playCount: "",
  showFee: false,
  discountInfo: ""
};
const fetchChannelApi = isDynamicChannel || channelData.showFee;

const TopicChannel = ({
  channelStyle: channelStyle,
  children: children,
  initSwiper: initSwiper
}) => {
  const [channel, setChannel] = useState({});
  useEffect(() => {
    if (!fetchChannelApi || !channelId) return setChannel(channelData);
    axios.get(`https://webapi.qingting.fm/material/biz/channels/${channelId}?type=fullsize`).then(res => {
      if (res.status === 200) {
        const data = res.data && res.data.data ? res.data.data : {};
        channelData.title = channelData.title || data.title;
        channelData.description = channelData.description || data.description;
        channelData.cover = channelData.cover || data.thumbs['200_thumb'];
        channelData.playCount = data.playcount;
        channelData.fee = data.purchase.fee;
        channelData.originalFee = data.purchase.original_fee;
        setChannel(channelData);
      }
    }, () => {
      setChannel(channelData);
    });
  }, []);
  useEffect(() => {
    if (!channel) return;
    if (initSwiper) initSwiper();
  }, [channel]);
  return <a style={channelStyle.container} onClick={() => {
    jssdk.route.jumpToChannel({
      channelId
    });
  }}>
      <img style={channelStyle.image} src={channel.cover ? channel.cover.replace('http://', 'https://') : ''} alt={channel.title} />
      <div style={channelStyle.info.container}>
        <div style={channelStyle.info.title}>{channel.title}</div>
        <div style={channelStyle.info.desc}>{channel.description}</div>
        <div style={channelStyle.info.extra}>
          <div style={channelStyle.info.extraLeft}>
            {channel.showFee && channel.discountInfo && channel.fee ? <span style={channelStyle.info.leftFee}>{channel.fee}元</span> : channel.playCount ? <span style={channelStyle.info.playCount}>{channel.playCount}</span> : null}
          </div>
          <div style={channelStyle.info.extraRight}>
            {channel.showFee && channel.discountInfo ? <span style={channelStyle.info.discount}>{channel.discountInfo}</span> : channel.showFee && channel.fee ? <span style={channelStyle.info.rightFee}>{channel.fee}元</span> : null}
          </div>
        </div>
      </div>
      {children}
    </a>;
};

const position = "bottom";
const effects = "null";
const effectParam = {
  scrollUpDisAppear: {
    top: 500
  },
  scrollUpShow: {
    top: 500
  }
};
const unit = "px";
const customStyle = {
  width: 70,
  height: 70,
  aspectRatio: "75:14",
  bgImg: "",
  bgColor: "rgba(93,0,128, 0)",
  top: 100,
  zIndex: 100,
  hasGradient: false,
  gradientDeg: 90,
  bgColor2: "transparent"
};

const FixedBar = ({
  children: children,
  position: position,
  customStyle: customStyle,
  effects: effects,
  effectParam: effectParam
}) => {
  const fixBar = useRef();
  const [fixStyle, setFixStyle] = useState({});
  useEffect__10(() => {
    const basicFixStyle = {
      position: 'fixed',
      height: 70,
      transition: 'transform 300ms ease-in',
      zIndex: customStyle.zIndex
    };
    const positionStyle = {
      topStyle: {
        top: 0,
        width: '100%'
      },
      bottomStyle: {
        bottom: 0,
        width: '100%'
      },
      leftStyle: {
        left: 0,
        top: '60%',
        width: 70
      },
      rightStyle: {
        right: 0,
        top: '60%',
        width: 70
      }
    };
    let widthRadio, heightRadio;

    if (customStyle.aspectRatio) {
      const radios = customStyle.aspectRatio.split(':');
      widthRadio = Number(radios[0]);
      heightRadio = Number(radios[1]);
    }

    switch (position) {
      case 'top':
        Object.assign(basicFixStyle, positionStyle.topStyle, customStyle);

        if (widthRadio) {
          basicFixStyle.height = window.innerWidth / widthRadio * heightRadio;
        }

        break;

      case 'bottom':
        Object.assign(basicFixStyle, positionStyle.bottomStyle, customStyle);

        if (widthRadio) {
          basicFixStyle.height = window.innerWidth / widthRadio * heightRadio;
        }

        break;

      case 'left':
        Object.assign(basicFixStyle, positionStyle.leftStyle, customStyle);
        break;

      case 'right':
        Object.assign(basicFixStyle, positionStyle.rightStyle, customStyle);
        break;

      default:
        break;
    }

    switch (effects) {
      case 'scrollUpDisAppear':
        window.addEventListener('scroll', () => {
          if (!fixBar.current) return;
          const param = effectParam[effects];

          if (document.body.scrollTop >= param.top || document.documentElement.scrollTop >= param.top) {
            fixBar.current.style.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
          } else {
            fixBar.current.style.transform = '';
          }
        });
        break;

      case 'scrollUpShow':
        basicFixStyle.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
        window.addEventListener('scroll', () => {
          if (!fixBar.current) return;
          const param = effectParam[effects];

          if (document.body.scrollTop >= param.top || document.documentElement.scrollTop >= param.top) {
            fixBar.current.style.transform = '';
          } else {
            fixBar.current.style.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
          }
        });
        break;

      default:
        break;
    }

    setFixStyle(basicFixStyle);
  }, []);
  return <div style={fixStyle} ref={fixBar}>{children}</div>;
};

export default (({}) => {
  const basicConfig = {
    title: "蜻蜓FM",
    shareTitle: "蜻蜓FM",
    shareImg: "https://sss.staging.qingting.fm/qt-builder-manage/upload_2bb66b65e93998005bb3751e72cb7f3b.png",
    shareSubTitle: "",
    shareLink: "",
    isHiddenAppShare: false,
    isHiddenWxShare: false
  };
  const containerConfig = {
    startTime: "",
    endTime: "",
    useServerTime: false,
    endRedirectUrl: "",
    redirectPromp: "当前活动已结束，自动跳入更多精彩活动",
    bgc: "#fff",
    themeColor: "#333",
    style: {},
    endTitle: "页面已过期~",
    beforeTitle: "活动还未开始，敬请期待~",
    bgimg: "",
    padding: "",
    margin: ""
  };
  const singleImage = {
    src: "https://sss.qingting.fm/bp/612c45806d40ddb5168df48e/image/7faadd83d3bd317eac88937710cf13e0.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    openNewWebview: true,
    openLazyload: false,
    openExpose: false
  };
  const imageContainerStyle = {
    marginTop: null,
    marginBottom: null,
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
    top: null,
    bottom: null,
    left: 0,
    right: 0,
    zIndex: 1,
    boxSizing: "border-box"
  };
  const imageStyle = {};
  const subTitleText = "欢迎加入大头诗词会";
  const subTitleStyle = {
    "paddingLeft": 10,
    "overflow": "hidden",
    "display": "-webkit-box",
    "WebkitLineClamp": 2,
    "WebkitBoxOrient": "vertical",
    "borderLeftColor": "#e6534f",
    "borderLeftWidth": 3,
    "borderLeftStyle": "solid",
    "marginTop": 20,
    "marginBottom": 20,
    "marginLeft": 15,
    "fontSize": 16,
    "color": "#333",
    "fontWeight": "bold",
    "lineHeight": 1,
    "textOverflow": "ellipsis"
  };
  const channelStyle = {
    image: {
      width: 60,
      height: "auto",
      position: "absolute"
    },
    info: {
      container: {},
      title: {
        fontSize: 14,
        color: "#333",
        fontWeight: 400,
        overflow: "hidden",
        textOverflow: "ellipsis",
        lineHeight: 1.2
      },
      desc: {
        fontSize: 12,
        color: "#606060",
        marginTop: 5,
        marginBottom: 8,
        maxHeight: 34,
        WebkitLineClamp: 2,
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        lineHeight: 1.2
      },
      extra: {
        color: "#999",
        lineHeight: 1
      },
      extraLeft: {
        float: 'left'
      },
      extraRight: {
        float: 'right'
      },
      leftFee: {
        color: '#fd5353',
        fontSize: 18
      },
      rightFee: {
        color: '#e13430'
      },
      playCount: {
        color: '#999',
        paddingLeft: 13,
        background: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAUCAYAAAC9BQwsAAAAAXNSR0IArs4c6QAAAcpJREFUOBGtk71Lw0AYxpuYSBER+jcouulgQQQRVwcVBDtICbQkLUIR3FRQdHXQQRzakK1C6aCzODjo4FjBuroIDgpVsLVq2/i7kpNYrTp48N77cc/zPnfcneI4Trher68FAoGipmk78Xj8jvjXodZqtbTrutPYCnHRtu2ZX1kAlEwm8wKp0w9WFMUOBoNLhmGU/XV/rEoS4GvsVSxSs6rVaiGdTo/4wf5YlQngY2IBvBI18j7cGTtaz+fzHaLmHx9EUUwkEoVQKBRGeRdzKWk02CyVSqeo97YlioVIJPJMg0XCSexW1BijWAH1eDNj+qQoi8JDPsINonzo1btRd1C28UpbogAnk8l7GsyqqmqSPnkNTJQTPxI9YMCyLAfylMzx438isr25RqNxIIls/1yTyXc+m832VCqVXc5kyHVIOXaw11YRlbFyuXwhSRCqbHcJ0jxx44siBJ3uG9gyJhtfQIqapnkJkTIX3Jy9iZ8ywE/ZR2VYlOhM6G7zKFa53+ZzlPgPIqAJfkeUhS6PdCO2yZWcSLDfC+IbpgPqlws0yem6vhCLxR5krdULonjUQ97CI2dJcY5sK7A1F8QUCpv4In4L0k0r6F/zd/SpuAHxGH1IAAAAAElFTkSuQmCC) no-repeat 0 50%',
        backgroundSize: '7px 9px'
      },
      discount: {
        fontSize: 13,
        color: '#fff',
        width: 85,
        display: 'block',
        textAlign: 'right',
        position: 'absolute',
        bottom: 0,
        right: 0,
        padding: '11px 11px 6px 0',
        background: 'url(data:image/png;base64,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) no-repeat',
        backgroundPosition: '0 1px',
        backgroundSize: '100% 100%'
      }
    },
    container: {
      fontSize: 12,
      backgroundColor: "#fff",
      borderColor: "#e3e3e3",
      borderWidth: 1,
      borderRadius: 4,
      marginTop: 10,
      marginBottom: 10,
      marginLeft: 15,
      marginRight: 15,
      padding: 10,
      borderStyle: "solid",
      cursor: "pointer",
      display: "block",
      position: "relative",
      overflow: "auto"
    }
  };
  channelStyle.info.container.minHeight = channelStyle.image.width;
  channelStyle.info.container.marginLeft = channelStyle.image.width + 10;
  const subTitleText__4 = "大头诗词会介绍";
  const subTitleStyle__4 = {
    "paddingLeft": 10,
    "overflow": "hidden",
    "display": "-webkit-box",
    "WebkitLineClamp": 2,
    "WebkitBoxOrient": "vertical",
    "borderLeftColor": "#e6534f",
    "borderLeftWidth": 3,
    "borderLeftStyle": "solid",
    "marginTop": 20,
    "marginBottom": 20,
    "marginLeft": 15,
    "fontSize": 16,
    "color": "#333",
    "fontWeight": "bold",
    "lineHeight": 1,
    "textOverflow": "ellipsis"
  };
  const singleImage__5 = {
    src: "https://sss.qingting.fm/bp/612c45806d40ddb5168df48e/image/f77e07491615ffdb2c5828a587104932.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    openNewWebview: true,
    openLazyload: false,
    openExpose: false
  };
  const imageContainerStyle__5 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
    top: null,
    bottom: null,
    left: 0,
    right: 0,
    zIndex: 1,
    boxSizing: "border-box"
  };
  const imageStyle__5 = {};
  const singleImage__6 = {
    src: "https://sss.qingting.fm/bp/612c45806d40ddb5168df48e/image/b34b5890ee2ff42420cde7b31350be3b.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    openNewWebview: true,
    openLazyload: false,
    openExpose: false
  };
  const imageContainerStyle__6 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
    top: null,
    bottom: null,
    left: 0,
    right: 0,
    zIndex: 1,
    boxSizing: "border-box"
  };
  const imageStyle__6 = {};
  const singleImage__7 = {
    src: "https://sss.qingting.fm/bp/612c45806d40ddb5168df48e/image/fdbdb795d470c6a11ff761e532d1e8a8.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    openNewWebview: true,
    openLazyload: false,
    openExpose: false
  };
  const imageContainerStyle__7 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
    top: null,
    bottom: null,
    left: 0,
    right: 0,
    zIndex: 1,
    boxSizing: "border-box"
  };
  const imageStyle__7 = {};
  const subTitleText__8 = "注意事项";
  const subTitleStyle__8 = {
    "paddingLeft": 10,
    "overflow": "hidden",
    "display": "-webkit-box",
    "WebkitLineClamp": 2,
    "WebkitBoxOrient": "vertical",
    "borderLeftColor": "#e6534f",
    "borderLeftWidth": 3,
    "borderLeftStyle": "solid",
    "marginTop": 20,
    "marginBottom": 20,
    "marginLeft": 15,
    "fontSize": 16,
    "color": "#333",
    "fontWeight": "bold",
    "lineHeight": 1,
    "textOverflow": "ellipsis"
  };
  const singleImage__9 = {
    src: "https://sss.qingting.fm/bp/612c45806d40ddb5168df48e/image/7d4cb2adff22680acf7af370a2445728.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    openNewWebview: true,
    openLazyload: false,
    openExpose: false
  };
  const imageContainerStyle__9 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
    top: null,
    bottom: null,
    left: 0,
    right: 0,
    zIndex: 1,
    boxSizing: "border-box"
  };
  const imageStyle__9 = {};
  const commonStyle = {
    backgroundImage: customStyle.bgImg ? `url(${customStyle.bgImg})` : customStyle.hasGradient ? `linear-gradient(${customStyle.gradientDeg}deg, ${customStyle.bgColor}, ${customStyle.bgColor2})` : 'none',
    backgroundSize: 'cover',
    backgroundColor: customStyle.bgColor,
    backgroundRepeat: 'no-repeat',
    zIndex: customStyle.zIndex,
    aspectRatio: customStyle.aspectRatio
  };
  const style = {
    top: {
      height: customStyle.height + unit
    },
    bottom: {
      height: customStyle.height + unit
    },
    left: {
      top: customStyle.top + unit,
      width: customStyle.width + unit,
      height: customStyle.height + unit
    },
    right: {
      top: customStyle.top + unit,
      width: customStyle.width + unit,
      height: customStyle.height + unit
    }
  };
  const singleImage__11 = {
    src: "https://sss.qingting.fm/bp/612c45806d40ddb5168df48e/image/6c114905fc3c659d6cd6e2cbc7b88203.png",
    link: "https://sss.qingting.fm/cashier/payments.html?item_id=6136f641dfe5e2bdd6a0f2c9",
    linkInApp: "https://sss.qingting.fm/cashier/payments.html?item_id=6136f641dfe5e2bdd6a0f2c9",
    linkOutApp: "https://sss.qingting.fm/cashier/payments.html?item_id=6136f641dfe5e2bdd6a0f2c9",
    openNewWebview: true,
    openLazyload: false,
    openExpose: false
  };
  const imageContainerStyle__11 = {
    "boxSizing": "border-box",
    "marginTop": null,
    "marginBottom": null,
    "marginLeft": "auto",
    "marginRight": "auto",
    "position": "relative",
    "top": null,
    "bottom": null,
    "left": 0,
    "right": 0,
    "zIndex": 1
  };
  const imageStyle__11 = {
    "borderWidth": null,
    "borderStyle": null,
    "borderColor": null,
    "borderTopLeftRadius": 15,
    "borderTopRightRadius": 15,
    "borderBottomRightRadius": 15,
    "borderBottomLeftRadius": 15
  };
  return <ContainnerProvider id="eb9" nodeId="dbc2c7f4-b9fe-43ae-93d0-2a0cccb5beb9" nodeType="component-container" containerConfig={containerConfig} basicConfig={basicConfig}><SingleImage id="d48" nodeId="513fa7f6-62ee-4b05-9c58-2fb5b41b1d48" nodeType="image" config={singleImage} containerStyle={imageContainerStyle} imageStyle={imageStyle}></SingleImage><div id="a4e" nodeId="25f25d43-54ce-40c9-87ca-78d730071a4e" nodeType="topic-sub-title" style={subTitleStyle}>{subTitleText}</div><TopicChannel id="db5" nodeId="e407f619-4532-4334-bfcb-4a47efa3adb5" nodeType="topic-channel" channelStyle={channelStyle} dynamicSwiper={fetchChannelApi}></TopicChannel><div id="e4a" nodeId="7e8b5e43-9a58-4740-8c25-5c0910381e4a" nodeType="topic-sub-title" style={subTitleStyle__4}>{subTitleText__4}</div><SingleImage id="a58" nodeId="aaf95093-2c7d-47a3-9893-6b5bf205da58" nodeType="image" config={singleImage__5} containerStyle={imageContainerStyle__5} imageStyle={imageStyle__5}></SingleImage><SingleImage id="ac2" nodeId="2868244c-30d3-41db-86f4-c27fd8b5cac2" nodeType="image" config={singleImage__6} containerStyle={imageContainerStyle__6} imageStyle={imageStyle__6}></SingleImage><SingleImage id="aac" nodeId="00b3367a-6947-44db-9f8f-772efb7ddaac" nodeType="image" config={singleImage__7} containerStyle={imageContainerStyle__7} imageStyle={imageStyle__7}></SingleImage><div id="bf1" nodeId="03b85976-6c0e-4349-ad56-1b58c69b2bf1" nodeType="topic-sub-title" style={subTitleStyle__8}>{subTitleText__8}</div><SingleImage id="afd" nodeId="0feb8887-483b-4d5d-b619-e4c0ea692afd" nodeType="image" config={singleImage__9} containerStyle={imageContainerStyle__9} imageStyle={imageStyle__9}></SingleImage><FixedBar id="bad" nodeId="7eff40c5-24d2-4634-a169-bc72cd2e3bad" nodeType="fixed-bar" position={position} customStyle={Object.assign(commonStyle, style[position])} effects={effects} effectParam={effectParam}><SingleImage id="c45" nodeId="6396b5a4-d77f-47d9-a095-89a31f94ac45" nodeType="image" config={singleImage__11} containerStyle={imageContainerStyle__11} imageStyle={imageStyle__11}></SingleImage></FixedBar></ContainnerProvider>;
});